import produce from 'immer';

import * as Types from './actionTypes';

export interface State {
  id: string | null;
  email: string | null;
  name: string | null;
}

const initialState: State = {
  id: null,
  email: null,
  name: null,
};

export default (
  state: State = initialState,
  action: Types.UserActionType,
): State => produce(state, (draft: State) => {
  switch (action.type) {
    case Types.SAVE_USER:
      draft.id = action.payload.id;
      draft.email = action.payload.email;
      // @ts-ignore
      draft.name = action.payload.name;
      break;
    case Types.REMOVE_USER:
      draft.id = null;
      draft.email = null;
      draft.name = null;
      break;
    default:
      break;
  }
});
